import ACTIONS from "../../constants/actions";
import Xhr from "../../helpers/Xhr";

export const setVisit = () => dispatch => {
	dispatch({type : ACTIONS.MAIN.SET_VISIT});
};

export const getFactors = () => dispatch => {
	Xhr.lineSettings().then((resp) => dispatch({
		type : ACTIONS.MAIN.GET_FACTORS,
		data : resp.data
	}));
};

// переключатель доп.исходы
export const toggleGlobalDopShow = () => dispatch => {
	dispatch({type : ACTIONS.MAIN.TOOGLE_DOP_SHOW});
};


// WEBPACK FOOTER //
// ./src/app/redux/actions/main.js